<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="weeklyCompliance" :options="weeklyComplianceReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { COMPLIANCE_PER_WEEK_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "WeeklyCompliance",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      weeklyCompliance: null,
    };
  },
  computed: {
    weeklyComplianceReport() {
      let series = this.weeklyCompliance.map((x) => {
        return {
          name: x["cohort"],
          data: x["compliance"].map((c) => [c["actionDate"], parseInt(c["userCount"])]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Weekly compliance",
        },
        xAxis: {
          categories: this.weeklyCompliance[0].compliance.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "# of users",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    weeklyCompliance: {
      query: COMPLIANCE_PER_WEEK_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
    },
  },
};
</script>
